module.exports = __webpack_public_path__ + "assets/img/icon09.1b8094f2.png";